import { useEventInfo } from '@shared/utils/eventInfo';
import { deriveCountryDefaults } from '@shared/utils/address/deriveCountryDefaults';

/**
 * Returns the ISO 3166-1 alpha-2 country code derived from the current event's locale.
 * Falls back to 'US' when the locale has no recognized region.
 *
 * Use this to seed address forms with the couple's country instead of a hardcoded default.
 */
export const useEventCountryCode = () => {
  const { eventInfo } = useEventInfo();
  return deriveCountryDefaults(eventInfo?.locale ?? undefined).countryCode;
};
